import * as React from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { Box } from '@mui/material';
import { AddButton } from '../button/button';
import { useState } from 'react'; import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/store/appStore';
import { useNavigate, useParams } from 'react-router-dom';
import { STATUS } from '../../utils/status';
import SnackbarNotification from '../snackbar/snackbarNotification';
import DeleteModal from '../modal/deleteModal';
import OutputJsonHeading from './outputJsonHeading';
import { JsonMapper } from './editor';
import { getOutputJsonTaskStatus, saveOutputJson, setClearOutputJson, setCreateSaveJsonStatus, setTaskStatus } from '../../redux/slices/outputJson';
import { clearFiles, setOutput } from '../../redux/reducers/formattedOutput';
import { clearRawJson } from '../../redux/slices/editor';
import TaskStatusModal from './taskStatusModal';
import { usePollingTaskStatus } from './usePollingStatus';
import UploadSchema from './UploadSchema';

export default function JsonMultiStepExport() {
    const [activeStep, setActiveStep] = useState(0);
    const [openSubmitModal, setOpenSubmitModal] = useState(false);
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams();
    const navigate = useNavigate();
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState<'success' | 'error' | 'info' | 'warning'>('success');
    const formattedOutput = useSelector((state: RootState) => state.output.output)
    const [parseError, setParseError] = useState<string | null>(null)
    const { saveoutputJsonResponse, saveOutputJsonMessage, saveOutputJsonStatus } = useSelector((state: RootState) => state.outputJson)
    const { getTaskStatusOutputJson, getTaskStatusOutputJsonMessage, taskStatusOutputJsonResponse } = useSelector((state: RootState) => state.outputJson)
    const selectedKey = useSelector((state: RootState) => state.mappedKey.selectedArrayKey);
    const [openModal, setOpenModal] = useState(false);

    const handleCloseSubmitModal = () => {
        setOpenSubmitModal(false);
    }

    const handleOpenSubmitModal = () => {
        setOpenSubmitModal(true);
    }

    const steps = ['Paste Output JSON Format', 'Upload Data & Map with JSON'];

    const handleFormattedOutputChange = (output: string) => {
        dispatch(setOutput(output))
    }

    React.useEffect(() => {
        dispatch(setClearOutputJson({}));
        dispatch(clearRawJson());
    }, [])

    // const [editorValue, setEditorValue] = useState(outputJson || '');

    // // Keep editor synced with Redux on load or change
    // useEffect(() => {
    //     setEditorValue(outputJson);
    // }, [outputJson]);

    const renderStepContent = (step: number) => {
        switch (step) {
            case 0:
                return (
                    <JsonMapper jsonTab={step} onFormattedOutputChange={handleFormattedOutputChange} parseError={parseError} setParseError={setParseError} />
                );

            case 1:
                return (
                    <JsonMapper jsonTab={step} onFormattedOutputChange={handleFormattedOutputChange} parseError={parseError} setParseError={setParseError} />
                );

            default:
                return null;
        }
    };

    const handleNext = () => {
        console.log("abc")
        const url = window.location.origin + window.location.pathname;
        window.history.pushState({}, '', url);
        setActiveStep((prevStep) => Math.min(prevStep + 1, steps.length - 1));
    };

    const handleAllocate = () => {
        dispatch(saveOutputJson({ id: id || '', output_json: formattedOutput, method: 'excel', mapped_key: selectedKey }))
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    const handleSnackbar = (message: string, severity: 'success' | 'error' | 'info' | 'warning') => {
        setSnackbarMessage(message);
        setSnackbarSeverity(severity);
        setSnackbarOpen(true);
    };

    React.useEffect(() => {
        if (saveOutputJsonStatus === STATUS.SUCESS) {
            handleSnackbar(saveOutputJsonMessage || 'success', 'success');
            dispatch(clearFiles())
            setOpenSubmitModal(false)
            const taskId = saveoutputJsonResponse?.data?.data?.task_id;
            if (taskId) {
                dispatch(getOutputJsonTaskStatus({ celery_task_id: taskId }));
            }
        }

        if (saveOutputJsonStatus === STATUS.FAILED) {
            handleSnackbar(saveOutputJsonMessage, 'error');
        }

        return () => {
            if (saveOutputJsonStatus === STATUS.SUCESS || saveOutputJsonStatus === STATUS.FAILED) {
                dispatch(setCreateSaveJsonStatus(STATUS.NOT_STARTED));
            }
        };
    }, [saveOutputJsonStatus, navigate, dispatch]);

    React.useEffect(() => {
        const status = taskStatusOutputJsonResponse?.data?.status;
        if (status === 'PENDING' || status === 'SUCCESS' || status === 'FAILURE') {
            setOpenModal(true);
        }
    }, [taskStatusOutputJsonResponse]);


    // React.useEffect(() => {
    //     if (taskStatusOutputJsonResponse?.data?.status === 'PENDING') {
    //         intervalRef.current = setInterval(() => {
    //             const taskId = taskStatusOutputJsonResponse?.data?.task_id;
    //             if (taskId) {
    //                 dispatch(getOutputJsonTaskStatus({ celery_task_id: taskId }));
    //             }
    //         }, POLLING_INTERVAL);
    //     }
    //     if (taskStatusOutputJsonResponse?.data?.status === 'SUCCESS' || taskStatusOutputJsonResponse?.data?.status === 'FAILURE') {
    //         if (intervalRef.current) {
    //             clearInterval(intervalRef.current);
    //             intervalRef.current = null;
    //         }
    //         //handleSnackbar(getTaskStatusOutputJsonMessage || 'success', 'success');
    //     }

    //     return () => {
    //         if (intervalRef.current) {
    //             clearInterval(intervalRef.current);
    //         }
    //     };
    // }, [taskStatusOutputJsonResponse, dispatch, getTaskStatusOutputJsonMessage]);

    const taskId =
        saveOutputJsonStatus === STATUS.SUCESS
            ? saveoutputJsonResponse?.data?.data?.task_id
            : undefined;

    usePollingTaskStatus({
        status: taskStatusOutputJsonResponse?.data?.status,
        taskId,
        onSuccess: () => {
            console.log('Polling finished successfully');
        },
        onFailure: () => {
            console.log('Polling failed');
        },
    });

    React.useEffect(() => {
  if (
    getTaskStatusOutputJson === STATUS.SUCESS &&
    taskStatusOutputJsonResponse?.data?.url
  ) {
    setSnackbarMessage("File Available for download.");
    setSnackbarSeverity("success");
    setSnackbarOpen(true);

    const url = taskStatusOutputJsonResponse.data.url;

    if (typeof url === "string") {
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const blobUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = blobUrl;

          const filename = url.split("/").pop()?.split("?")[0] || "downloaded-file";
          link.download = filename;

          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(blobUrl);

          dispatch(clearRawJson());
        })
        .catch(() => alert("Failed to download file"));
    }
  }

  if (getTaskStatusOutputJson === STATUS.FAILED) {
    setSnackbarMessage(getTaskStatusOutputJsonMessage);
    setSnackbarSeverity("error");
    setSnackbarOpen(true);
  }

  return () => {
    if (
      getTaskStatusOutputJson === STATUS.SUCESS ||
      getTaskStatusOutputJson === STATUS.FAILED
    ) {
      dispatch(setTaskStatus(STATUS.NOT_STARTED));
    }
  };
}, [getTaskStatusOutputJson]);


    const isNextDisabled = () => {
        if (activeStep === 0 && parseError) {
            return true;
        }
        return false;
    };

    const handleBack = () => {
        const url = window.location.origin + window.location.pathname;
        window.history.pushState({}, '', url);
        setActiveStep((prevStep) => Math.max(prevStep - 1, 0));
    };

    return (
        <div style={{ width: '100vw', height: '100vh', overflow: 'hidden' }}>
            <Box sx={{ flexGrow: 1, bgcolor: '#F7F9FA', p: '0rem' }}>
                <OutputJsonHeading />
            </Box>

            <Box component="main" sx={{ flexGrow: 1, bgcolor: '#F7F9FA', p: '1rem' }}>
                <Box sx={{ width: '100%' }}>
                    <Stepper activeStep={activeStep} alternativeLabel>
                        {steps.map((label, index) => (
                            <Step key={index}>
                                <StepLabel>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </Box>
            </Box>
            <Box component="main" sx={{ flexGrow: 1, bgcolor: '#F7F9FA', p: '2.5rem', paddingTop: 'none' }}>
                <section
                    style={{
                        height: 'calc(100vh - 300px)',
                        overflowY: 'auto',
                        padding: '12px, 0px, 12px, 0px',
                        marginBottom: '15rem',
                        flexGrow: 1
                    }}
                >
                    {renderStepContent(activeStep)}
                </section>
            </Box>
            <section className="fixed bottom-0 inset-x-0 h-[58px] bg-white z-40 drop-shadow">
                <Box
                    sx={{
                        mt: '0.1rem',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        mr: '0.4rem'
                    }}
                >
                    {activeStep !== 0 && (
                        <AddButton variant="contained" onClick={handleBack}>
                            Previous
                        </AddButton>
                    )}

                    <AddButton
                        variant="contained"
                        onClick={activeStep === steps.length - 1 ? handleOpenSubmitModal : handleNext}
                        disabled={isNextDisabled()}
                    >
                        {activeStep === steps.length - 1 ? 'Save & Export' : 'Next'}
                    </AddButton>

                </Box>
            </section>
            
            <SnackbarNotification
                open={snackbarOpen}
                message={snackbarMessage}
                severity={snackbarSeverity}
                onClose={handleSnackbarClose}
            />
            <DeleteModal
                open={openSubmitModal}
                onCancel={handleCloseSubmitModal}
                onConfirm={handleAllocate}
                deleteText={'Save'}
                isButtonLoading={saveOutputJsonStatus === STATUS.PENDING}
            />
            <TaskStatusModal
                open={openModal}
                onClose={() => setOpenModal(false)}
                taskStatusData={taskStatusOutputJsonResponse?.data}
            />
        </div>
    );
}
